import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { DomainService } from 'src/app/core/domain/domain.service';
import { WindowRef } from 'src/app/core/domain/window-ref';
import { ProfileService } from 'src/app/core/translation/profile.service';

@Component({
    selector: 'app-page-not-found',
    templateUrl: './page-not-found.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: true
})
export class PageNotFoundComponent implements OnInit {
  private readonly translationIndex = 'pageNotFound';
  private readonly commonIndex = 'common';
  message: any;
  homeUrl: string;

  constructor(private readonly pfs: ProfileService, private readonly windowRef: WindowRef, private readonly domain: DomainService) { }

  ngOnInit(): void {
    this.message = { ...this.pfs.messages[this.commonIndex], ...this.pfs.messages[this.translationIndex]};
    this.homeUrl = this.domain.getHomeUrl(this.windowRef.getHostname());
  }

}
